<template>
	<div class="myaudio">
		<audio @timeupdate="updateProgress" controls ref="audioRef" style="display: none">
			<source :src="fileurl" type="audio/mpeg"/>
			您的浏览器不支持音频播放
		</audio>
		<div class="audio-right">
			<img class="play-icon" :src="audioStatus!=='stop'? require('../../assets/img/teacher/playing.png'):require('../../assets/img/teacher/play.png')"  @click="playAudio" alt="">
			<div class="progress-bar-bg">
				<el-slider :show-tooltip="false" @change="onChange" v-model="value"/>
			</div>
			<div class="audio-time" style="min-height: 10px">
				<span class="audio-length-current" id="audioCurTime">{{videoStart}}</span>/
				<span class="audio-length-total">{{transTime(duration)}}</span>
			</div>
		</div>
	</div>
</template>

<script>
  export default {
    props: ["fileurl", 'duration', 'play_status'],
    data: function () {
      return {
        audioStatus: 'stop',
        videoStart: '00:00',
        value: 0,

      };
    },
    methods: {
      //播放暂停控制
      playAudio(e) {
        let recordAudio = this.$refs.audioRef; //获取audio元素
        if (recordAudio.paused && !this.play_status) {
          recordAudio.play();
          this.audioStatus = "run"
          this.$emit('play_status',true)
        } else if (this.play_status){

          recordAudio.pause();
          this.audioStatus = "stop"
          this.$emit('play_status',false)
        }
      },
      //更新进度条与当前播放时间
      updateProgress(e) {
        let recordAudio = this.$refs.audioRef; //获取audio元素
        let time = e.target.currentTime+0.3
        var value = time / this.duration
        this.value = value * 100
        if (this.$refs.audioRef.paused && time>=recordAudio.duration) {
            this.audioStatus = 'stop'
            this.$emit('play_status',false)
            this.value = 0
            this.videoStart = this.transTime(0)
            return
        }
        this.value = value * 100
        this.videoStart = this.transTime(this.$refs.audioRef.currentTime)
      },
      /**
       * 音频播放时间换算
       * @param {number} value - 音频当前播放时间，单位秒
       */
      transTime(value) {
        var time = "";
        var h = parseInt(value / 3600);
        value %= 3600;
        var m = parseInt(value / 60);
        m = m < 10 ? '0' + m : m
        var s = parseInt(value % 60);
        s = s < 10 ? '0' + s : s
        time = m + ":" + s;
        return time;
      },
      // 进度条
      onChange(val) {
        let recordAudio = this.$refs.audioRef; //获取audio元素
        if (!recordAudio.paused || recordAudio.currentTime != 0) {
          recordAudio.currentTime = recordAudio.duration * val / 100
          this.videoStart = this.transTime(val / 100 * this.duration)
        }
      }
    }
  }
</script>

<style lang="less" scoped>
	.audio-right {
		width: 100%;
		margin-top: 10px;
		height: 49px;
		line-height: 49px;
		background: #ffde00;
		border-radius: 6px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 15px;
		.play-icon{
			width: 24px;
			height: 24px;
			margin-right: 10px;
			cursor: pointer;
		}
		.dialogAudioPlay {
			cursor: pointer;
			color: #fff;
			font-size: 20px;
		}

		.progress-bar-bg {
			flex: 1;

			/deep/ .el-slider {
				margin-right: 20px;
				.el-slider__button{
					display: none;
				}
				.el-slider__runway{
					height: 4px;
				}
				.el-slider__bar{
					height: 4px;
					background-color: #ffffff;
				}
			}
		}

		.progress-bar {
			background-color: #fff;
			width: 0%;
			height: 2px;
		}

		.audio-time {
			overflow: hidden;
			color: #fff;
			font-size: 14px;

			span {
				color: #fff;
			}

			.audio-length-total {
				float: right;
			}

			.audio-length-current {
				float: left;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/audio/index.vue